import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalCellularOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_cellular_off"}/>
}
